import api from "./api";

export const removeGift = async (orderFormId, giftId) => {
  const { data } = await api.post(
    `/checkout/cart/${orderFormId}/selectable-gifts/${giftId}`,
    []
  );

  return data;
};

export const addGift = async (orderFormId, giftId, availableGifts) => {
  const selectedGifts = await availableGifts.map((gift, index) => ({
    id: gift.id,
    seller: gift.seller,
    index
  }));

  const { data } = await api.post(
    `/checkout/cart/${orderFormId}/selectable-gifts/${giftId}`,
    [selectedGifts[0]]
  );

  return data;
};

export const updateGift = async (
  orderFormId,
  giftId,
  quantity,
  availableGifts
) => {
  const selectedGifts = await availableGifts
    .slice(0, quantity)
    .map((gift, index) => ({
      id: gift.id,
      seller: gift.seller,
      index
    }));

  const { data } = await api.post(
    `/checkout/cart/${orderFormId}/selectable-gifts/${giftId}`,
    selectedGifts
  );

  return data;
};
